import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const Navigation = () => {
  const { user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    isActive
      ? "text-amber-500 font-semibold"
      : "text-slate-700 hover:text-amber-500 transition-colors duration-200";

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 flex justify-between items-center h-16">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-2 text-slate-900 font-bold text-xl tracking-tight hover:text-amber-500 transition-colors"
        >
          <span className="text-2xl">🐾</span>
          PetHouse
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-7">
          <NavLink to="/" end className={linkClass}>
            Home
          </NavLink>
          <NavLink to="/explore" className={linkClass}>
            Explore Pets
          </NavLink>

          {user?.email && (
            <NavLink to="/dashboard" className={linkClass}>
              Dashboard
            </NavLink>
          )}

          {user?.displayName && (
            <span className="text-slate-500 text-sm">
              Hi, {user.displayName.split(" ")[0]}
            </span>
          )}

          {user?.email ? (
            <button
              onClick={logout}
              className="px-5 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
            >
              Logout
            </button>
          ) : (
            <Link
              to="/login"
              className="px-5 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
            >
              Login
            </Link>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-slate-700 p-1"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isMenuOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
        } bg-white border-t border-gray-100`}
      >
        <div className="flex flex-col px-6 py-4 gap-4">
          <NavLink
            to="/"
            end
            className={linkClass}
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </NavLink>
          <NavLink
            to="/explore"
            className={linkClass}
            onClick={() => setIsMenuOpen(false)}
          >
            Explore Pets
          </NavLink>
          {user?.email && (
            <NavLink
              to="/dashboard"
              className={linkClass}
              onClick={() => setIsMenuOpen(false)}
            >
              Dashboard
            </NavLink>
          )}
          {user?.displayName && (
            <span className="text-slate-400 text-sm">
              Hi, {user.displayName.split(" ")[0]}
            </span>
          )}
          {user?.email ? (
            <button
              onClick={() => {
                logout();
                setIsMenuOpen(false);
              }}
              className="w-fit px-5 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
            >
              Logout
            </button>
          ) : (
            <Link
              to="/login"
              onClick={() => setIsMenuOpen(false)}
              className="w-fit px-5 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
            >
              Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
